import { Spinner } from '@/common/components/spinner';

export function PageLoader() {
  return (
    <div className="flex flex-col grow items-center justify-center">
      <Spinner color="primary" size="md" />
    </div>
  );
}
